import axios from 'axios';
import { Storage } from 'react-jhipster';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

export const ACTION_TYPES = {
  GET_USERINFO: 'account/GET_USERINFO',
  CREATE_PASSWORD: 'account/CREATE_PASSWORD',
  RESET: 'account/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  createSuccess: false,
  createFailure: false,
  userRequest: {} as any,
  userInfo: {} as any
};

export type PasswordSetState = Readonly<typeof initialState>;

// Reducer
export default (state: PasswordSetState = initialState, action): PasswordSetState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.CREATE_PASSWORD):
    case REQUEST(ACTION_TYPES.GET_USERINFO):
      return {
        ...state,
        errorMessage: null,
        createSuccess: false,
        loading: true
      };
    case FAILURE(ACTION_TYPES.CREATE_PASSWORD):
      return {
        ...initialState,
        loading: false,
        createSuccess: false,
        createFailure: true
      };
    case SUCCESS(ACTION_TYPES.CREATE_PASSWORD):
      return {
        ...state,
        loading: false,
        createSuccess: true,
        createFailure: false,
        userRequest: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_USERINFO):
      return {
        ...initialState,
        userInfo: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

// Actions
const apiUrl = 'api/register';

export const savePassword = (username, key, password) => ({
  type: ACTION_TYPES.CREATE_PASSWORD,
  payload: axios.post(`${apiUrl}/verify`, { username, key, password })
});

export const getUserInfo = (username, key) => ({
  type: ACTION_TYPES.GET_USERINFO,
  payload: axios.get(`${apiUrl}/verify/${username}`, {
    params: {
      key: key
    }
  })
})

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
